// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`render 1`] = `
Object {
  "asFragment": [Function],
  "baseElement": <body>
    <div>
      <div
        class="MuiGrid-root MuiGrid-container"
      >
        <div
          class="MuiGrid-root banner-mobileport MuiGrid-item MuiGrid-grid-xs-4"
        >
          <div
            class="MuiContainer-root WithStyles(ForwardRef(Container))-root-8 MuiContainer-maxWidthLg"
          >
            <a
              data-turbolinks="false"
              href="/"
            >
              <img
                alt="Dr. Bill Logo"
                class="img-root-9"
                src="test-file-stub"
              />
            </a>
            <div
              class="WithStyles(ForwardRef(Typography))-root-10"
              variant="h2"
            >
              Welcome to Dr.Bill!
            </div>
            <p
              class="MuiTypography-root WithStyles(ForwardRef(Typography))-root-11 MuiTypography-body2"
            >
              We're excited to give you back some valuable free time—and help ensure you are paid accurately for the work that you do.
            </p>
            <img
              alt="dashboard, new patient, new claim tabs"
              class="img-root-12"
              src="test-file-stub"
            />
          </div>
        </div>
        <div
          class="MuiGrid-root form-mobileport MuiGrid-item MuiGrid-grid-xs-8"
        >
          <div
            class="div-root-13 header-mobile"
          >
            <a
              data-turbolinks="false"
              href="/"
            >
              <img
                class="img-root-14"
                src="test-file-stub"
              />
            </a>
          </div>
          <div
            class="MuiContainer-root makeStyles-stepperPadding-3 MuiContainer-maxWidthSm"
          >
            <div
              class="MuiPaper-root MuiStepper-root MuiStepper-horizontal makeStyles-root-15 MuiStepper-alternativeLabel MuiPaper-elevation0"
            >
              <div
                class="MuiStep-root MuiStep-horizontal MuiStep-alternativeLabel"
              >
                <span
                  class="MuiStepLabel-root MuiStepLabel-horizontal MuiStepLabel-alternativeLabel"
                >
                  <span
                    class="MuiStepLabel-iconContainer MuiStepLabel-alternativeLabel"
                  >
                    <svg
                      aria-hidden="true"
                      class="MuiSvgIcon-root MuiStepIcon-root MuiStepIcon-active"
                      focusable="false"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        cx="12"
                        cy="12"
                        r="12"
                      />
                      <text
                        class="MuiStepIcon-text"
                        text-anchor="middle"
                        x="12"
                        y="16"
                      >
                        1
                      </text>
                    </svg>
                  </span>
                  <span
                    class="MuiStepLabel-labelContainer"
                  >
                    <span
                      class="MuiTypography-root MuiStepLabel-label makeStyles-label-16 MuiStepLabel-alternativeLabel MuiStepLabel-active MuiTypography-body2 MuiTypography-displayBlock"
                    >
                      Create login
                    </span>
                  </span>
                </span>
              </div>
              <div
                class="MuiStep-root MuiStep-horizontal MuiStep-alternativeLabel"
              >
                <div
                  class="MuiStepConnector-root MuiStepConnector-horizontal MuiStepConnector-alternativeLabel Mui-disabled"
                >
                  <span
                    class="MuiStepConnector-line WithStyles(ForwardRef(StepConnector))-line-18 MuiStepConnector-lineHorizontal"
                  />
                </div>
                <span
                  class="MuiStepLabel-root MuiStepLabel-horizontal Mui-disabled makeStyles-disabled-17 MuiStepLabel-alternativeLabel"
                >
                  <span
                    class="MuiStepLabel-iconContainer MuiStepLabel-alternativeLabel"
                  >
                    <svg
                      aria-hidden="true"
                      class="MuiSvgIcon-root MuiStepIcon-root"
                      focusable="false"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        cx="12"
                        cy="12"
                        r="12"
                      />
                      <text
                        class="MuiStepIcon-text"
                        text-anchor="middle"
                        x="12"
                        y="16"
                      >
                        2
                      </text>
                    </svg>
                  </span>
                  <span
                    class="MuiStepLabel-labelContainer"
                  >
                    <span
                      class="MuiTypography-root MuiStepLabel-label makeStyles-label-16 MuiStepLabel-alternativeLabel MuiTypography-body2 MuiTypography-displayBlock"
                    >
                      Confirm email
                    </span>
                  </span>
                </span>
              </div>
              <div
                class="MuiStep-root MuiStep-horizontal MuiStep-alternativeLabel"
              >
                <div
                  class="MuiStepConnector-root MuiStepConnector-horizontal MuiStepConnector-alternativeLabel Mui-disabled"
                >
                  <span
                    class="MuiStepConnector-line WithStyles(ForwardRef(StepConnector))-line-18 MuiStepConnector-lineHorizontal"
                  />
                </div>
                <span
                  class="MuiStepLabel-root MuiStepLabel-horizontal Mui-disabled makeStyles-disabled-17 MuiStepLabel-alternativeLabel"
                >
                  <span
                    class="MuiStepLabel-iconContainer MuiStepLabel-alternativeLabel"
                  >
                    <svg
                      aria-hidden="true"
                      class="MuiSvgIcon-root MuiStepIcon-root"
                      focusable="false"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        cx="12"
                        cy="12"
                        r="12"
                      />
                      <text
                        class="MuiStepIcon-text"
                        text-anchor="middle"
                        x="12"
                        y="16"
                      >
                        3
                      </text>
                    </svg>
                  </span>
                  <span
                    class="MuiStepLabel-labelContainer"
                  >
                    <span
                      class="MuiTypography-root MuiStepLabel-label makeStyles-label-16 MuiStepLabel-alternativeLabel MuiTypography-body2 MuiTypography-displayBlock"
                    >
                      Final details
                    </span>
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div
            class="MuiContainer-root MuiContainer-maxWidthSm"
          >
            <div
              class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
            />
            <div
              class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-3"
            >
              <div
                class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
              >
                <h3
                  class="MuiTypography-root makeStyles-heading-1 MuiTypography-h3"
                >
                  bar
                  <span
                    style="position: relative;"
                  >
                    cat
                    <img
                      alt="yellow underline"
                      class="underline-image"
                      src="test-file-stub"
                    />
                  </span>
                </h3>
                <p
                  class="MuiTypography-root makeStyles-body-2 MuiTypography-body1"
                >
                  Plan foo sign up description
                  <a
                    role="button"
                  >
                    <span
                      style="font-weight: bold;"
                    >
                      Terms apply.
                    </span>
                  </a>
                </p>
              </div>
              <div />
            </div>
          </div>
        </div>
      </div>
    </div>
  </body>,
  "container": <div>
    <div
      class="MuiGrid-root MuiGrid-container"
    >
      <div
        class="MuiGrid-root banner-mobileport MuiGrid-item MuiGrid-grid-xs-4"
      >
        <div
          class="MuiContainer-root WithStyles(ForwardRef(Container))-root-8 MuiContainer-maxWidthLg"
        >
          <a
            data-turbolinks="false"
            href="/"
          >
            <img
              alt="Dr. Bill Logo"
              class="img-root-9"
              src="test-file-stub"
            />
          </a>
          <div
            class="WithStyles(ForwardRef(Typography))-root-10"
            variant="h2"
          >
            Welcome to Dr.Bill!
          </div>
          <p
            class="MuiTypography-root WithStyles(ForwardRef(Typography))-root-11 MuiTypography-body2"
          >
            We're excited to give you back some valuable free time—and help ensure you are paid accurately for the work that you do.
          </p>
          <img
            alt="dashboard, new patient, new claim tabs"
            class="img-root-12"
            src="test-file-stub"
          />
        </div>
      </div>
      <div
        class="MuiGrid-root form-mobileport MuiGrid-item MuiGrid-grid-xs-8"
      >
        <div
          class="div-root-13 header-mobile"
        >
          <a
            data-turbolinks="false"
            href="/"
          >
            <img
              class="img-root-14"
              src="test-file-stub"
            />
          </a>
        </div>
        <div
          class="MuiContainer-root makeStyles-stepperPadding-3 MuiContainer-maxWidthSm"
        >
          <div
            class="MuiPaper-root MuiStepper-root MuiStepper-horizontal makeStyles-root-15 MuiStepper-alternativeLabel MuiPaper-elevation0"
          >
            <div
              class="MuiStep-root MuiStep-horizontal MuiStep-alternativeLabel"
            >
              <span
                class="MuiStepLabel-root MuiStepLabel-horizontal MuiStepLabel-alternativeLabel"
              >
                <span
                  class="MuiStepLabel-iconContainer MuiStepLabel-alternativeLabel"
                >
                  <svg
                    aria-hidden="true"
                    class="MuiSvgIcon-root MuiStepIcon-root MuiStepIcon-active"
                    focusable="false"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      cx="12"
                      cy="12"
                      r="12"
                    />
                    <text
                      class="MuiStepIcon-text"
                      text-anchor="middle"
                      x="12"
                      y="16"
                    >
                      1
                    </text>
                  </svg>
                </span>
                <span
                  class="MuiStepLabel-labelContainer"
                >
                  <span
                    class="MuiTypography-root MuiStepLabel-label makeStyles-label-16 MuiStepLabel-alternativeLabel MuiStepLabel-active MuiTypography-body2 MuiTypography-displayBlock"
                  >
                    Create login
                  </span>
                </span>
              </span>
            </div>
            <div
              class="MuiStep-root MuiStep-horizontal MuiStep-alternativeLabel"
            >
              <div
                class="MuiStepConnector-root MuiStepConnector-horizontal MuiStepConnector-alternativeLabel Mui-disabled"
              >
                <span
                  class="MuiStepConnector-line WithStyles(ForwardRef(StepConnector))-line-18 MuiStepConnector-lineHorizontal"
                />
              </div>
              <span
                class="MuiStepLabel-root MuiStepLabel-horizontal Mui-disabled makeStyles-disabled-17 MuiStepLabel-alternativeLabel"
              >
                <span
                  class="MuiStepLabel-iconContainer MuiStepLabel-alternativeLabel"
                >
                  <svg
                    aria-hidden="true"
                    class="MuiSvgIcon-root MuiStepIcon-root"
                    focusable="false"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      cx="12"
                      cy="12"
                      r="12"
                    />
                    <text
                      class="MuiStepIcon-text"
                      text-anchor="middle"
                      x="12"
                      y="16"
                    >
                      2
                    </text>
                  </svg>
                </span>
                <span
                  class="MuiStepLabel-labelContainer"
                >
                  <span
                    class="MuiTypography-root MuiStepLabel-label makeStyles-label-16 MuiStepLabel-alternativeLabel MuiTypography-body2 MuiTypography-displayBlock"
                  >
                    Confirm email
                  </span>
                </span>
              </span>
            </div>
            <div
              class="MuiStep-root MuiStep-horizontal MuiStep-alternativeLabel"
            >
              <div
                class="MuiStepConnector-root MuiStepConnector-horizontal MuiStepConnector-alternativeLabel Mui-disabled"
              >
                <span
                  class="MuiStepConnector-line WithStyles(ForwardRef(StepConnector))-line-18 MuiStepConnector-lineHorizontal"
                />
              </div>
              <span
                class="MuiStepLabel-root MuiStepLabel-horizontal Mui-disabled makeStyles-disabled-17 MuiStepLabel-alternativeLabel"
              >
                <span
                  class="MuiStepLabel-iconContainer MuiStepLabel-alternativeLabel"
                >
                  <svg
                    aria-hidden="true"
                    class="MuiSvgIcon-root MuiStepIcon-root"
                    focusable="false"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      cx="12"
                      cy="12"
                      r="12"
                    />
                    <text
                      class="MuiStepIcon-text"
                      text-anchor="middle"
                      x="12"
                      y="16"
                    >
                      3
                    </text>
                  </svg>
                </span>
                <span
                  class="MuiStepLabel-labelContainer"
                >
                  <span
                    class="MuiTypography-root MuiStepLabel-label makeStyles-label-16 MuiStepLabel-alternativeLabel MuiTypography-body2 MuiTypography-displayBlock"
                  >
                    Final details
                  </span>
                </span>
              </span>
            </div>
          </div>
        </div>
        <div
          class="MuiContainer-root MuiContainer-maxWidthSm"
        >
          <div
            class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
          />
          <div
            class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-3"
          >
            <div
              class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
            >
              <h3
                class="MuiTypography-root makeStyles-heading-1 MuiTypography-h3"
              >
                bar
                <span
                  style="position: relative;"
                >
                  cat
                  <img
                    alt="yellow underline"
                    class="underline-image"
                    src="test-file-stub"
                  />
                </span>
              </h3>
              <p
                class="MuiTypography-root makeStyles-body-2 MuiTypography-body1"
              >
                Plan foo sign up description
                <a
                  role="button"
                >
                  <span
                    style="font-weight: bold;"
                  >
                    Terms apply.
                  </span>
                </a>
              </p>
            </div>
            <div />
          </div>
        </div>
      </div>
    </div>
  </div>,
  "debug": [Function],
  "findAllByAltText": [Function],
  "findAllByDisplayValue": [Function],
  "findAllByLabelText": [Function],
  "findAllByPlaceholderText": [Function],
  "findAllByRole": [Function],
  "findAllByTestId": [Function],
  "findAllByText": [Function],
  "findAllByTitle": [Function],
  "findByAltText": [Function],
  "findByDisplayValue": [Function],
  "findByLabelText": [Function],
  "findByPlaceholderText": [Function],
  "findByRole": [Function],
  "findByTestId": [Function],
  "findByText": [Function],
  "findByTitle": [Function],
  "getAllByAltText": [Function],
  "getAllByDisplayValue": [Function],
  "getAllByLabelText": [Function],
  "getAllByPlaceholderText": [Function],
  "getAllByRole": [Function],
  "getAllByTestId": [Function],
  "getAllByText": [Function],
  "getAllByTitle": [Function],
  "getByAltText": [Function],
  "getByDisplayValue": [Function],
  "getByLabelText": [Function],
  "getByPlaceholderText": [Function],
  "getByRole": [Function],
  "getByTestId": [Function],
  "getByText": [Function],
  "getByTitle": [Function],
  "queryAllByAltText": [Function],
  "queryAllByDisplayValue": [Function],
  "queryAllByLabelText": [Function],
  "queryAllByPlaceholderText": [Function],
  "queryAllByRole": [Function],
  "queryAllByTestId": [Function],
  "queryAllByText": [Function],
  "queryAllByTitle": [Function],
  "queryByAltText": [Function],
  "queryByDisplayValue": [Function],
  "queryByLabelText": [Function],
  "queryByPlaceholderText": [Function],
  "queryByRole": [Function],
  "queryByTestId": [Function],
  "queryByText": [Function],
  "queryByTitle": [Function],
  "rerender": [Function],
  "unmount": [Function],
}
`;
